/**
 * The marketing apex (Firebase Hosting serves the static landing there and
 * rewrites everything else to the portal's Cloud Run service). App routes
 * reached via the apex 308 to the portal host, where the session cookie
 * lives (proxy.ts). Shared with the client so the auth provider knows a page
 * served on the apex can never hold a session — a sign-in sync from there
 * would follow the 308 cross-origin and lose its Authorization header.
 * Safe for client bundles: constants only.
 */
export const APEX_HOSTS: ReadonlySet<string> = new Set(["aireserve.com", "www.aireserve.com"]);
export const PORTAL_ORIGIN = "https://portal.aireserve.com";

export function isApexHost(host: string): boolean {
  const bareHost = host.split(":")[0]?.toLowerCase() ?? "";
  return APEX_HOSTS.has(bareHost);
}
